/* eslint-disable no-use-before-define */
import axios from 'axios';
import AppConstants from '../Constants/AppConstants';
const APPURL = require('../Constants/URLConstants');

export const AxiosCall = async ({method, path, data, auth_key, pk_key}) => {
  var header = {
    'Content-Type': 'application/json',
  };
  if (auth_key) {
    header['x-auth-key'] = auth_key;
  }

  if (AppConstants.currencies?.length > 0) {
    const defaultCurrency = AppConstants.currencies.find(
      currency => currency.default,
    );
    header['x-currency'] = defaultCurrency?.code;
  }

  if (AppConstants.languages?.length > 0) {
    const defaultLanguage = AppConstants.languages.find(
      language => language.default,
    );
    header['X-Language'] = defaultLanguage?.code;
  }

  if (pk_key) {
    header.Authorization = `Bearer ${pk_key}`;
  }

  var BaseURL = APPURL.URLPaths.BaseURL;
  if (!AppConstants.isDevelopment) {
    BaseURL = APPURL.URLPaths.productionBaseURL;
  }

  return await axios({
    url: BaseURL + path,
    method: method,
    responseType: 'json',
    headers: header,
    data: data,
  });
};
